// extracted by mini-css-extract-plugin
export default {"header":"Header_header__23ITg","center":"Header_center__6yxXv"};